import { useParams } from "react-router-dom";
import { createContext, useCallback, useEffect, useState } from "react";
import { Iuser } from "@api/types";
import { initialUserState } from "@redux/slices/UserSlice";
import { useLazyQuery } from "@apollo/client";
import { GET_SINGLE_USER } from "@graphql/Queries";
import { toastErrorMessage } from "@utils/utils";
import UserProfile from "@components/user-profile";

export const profileContext = createContext<{
  user: Iuser;
}>({
  user: initialUserState,
});

export default function User(): JSX.Element {
  const { userUid } = useParams();
  const [user, setUser] = useState<Iuser>(initialUserState);
  const [fetchUser] = useLazyQuery(GET_SINGLE_USER, {
    onCompleted: (data) => {
      updateUser(data.getSingleUser);
    },
    onError: (error) => {
      toastErrorMessage(error.message);
    },
  });

  const updateUser = useCallback(
    (u: Iuser) => {
      setUser(u);
    },
    [user]
  );

  useEffect(() => {
    (async () => {
      if (userUid) {
        await fetchUser({
          variables: {
            userId: userUid,
          },
        });
      }
    })();
  }, []);
  return (
    <profileContext.Provider
      value={{
        user,
      }}
    >
      <UserProfile />
    </profileContext.Provider>
  );
}
